<template>
  <div class>
    <div class="row">
      <div class="col-md-12 col-sm-18">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-5">
                <form-text label="Search Conversations" name="searchconversations" v-model="searchQuery"></form-text>
              </div>
              <div class="col-md-2" v-if="org['curOrg']['role'] == 99">
                <router-link to="/operations/wire/create" class="btn btn-success">Add</router-link>
              </div>
            </div>
            <br>
            <conversations-table :data="filteredData" :columns="gridColumns" :filter-key="searchQuery"></conversations-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConversationsTable from "./ConversationsTable";
import FormText from "../../elements/Form/FormText";
import database from "../../webmaster/Database/database";
import store from "../../webmaster/Store/vuex";

export default {
  name: "conversations",
  components: {
    "conversations-table": ConversationsTable,
    "form-text": FormText
  },
  data() {
    return {
      org: store.state.usermain,
      conversations: [],
      searchQuery: "",
      gridColumns: [
        "name",
        "members",
      ],
      gridColumns_export: {
        name: "String",
        members: "String",
      }
    };
  },
  created:function(){
    //Populate users
    var self = this
    var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/wire/chats'
    this.$bindAsArray('conversations', database.getRef(ref));
  },
  computed: {
    filteredData:function(){
      var data = this.conversations;
      
      for (var key in data){
        if (!data[key]['filtered']) {
          data[key].members = Object.values(data[key].members).join(", ");
        }

        data[key]['filtered'] = true;
      }

      return data
    }
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// Wire.vue?44d3ac22